export const STATISTICS_IDENTIFIER = '--stats--'
export const SETTINGS_IDENTIFIER = '--settings--'
export const SORT_DIRECTION_ASC  = 'ASC'
export const SORT_DIRECTION_DESC = 'DESC'